module.exports = __webpack_public_path__ + "img/dash-circle.19ee5fb0.svg";